import { NavLink, Outlet } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';
import { Video, Radio, Scan, PowerOff } from 'lucide-react';
import { cn } from '@/lib/utils';

interface Tab {
  to: string;
  label: string;
  Icon: LucideIcon;
}

const TABS: Tab[] = [
  { to: '/devices/cameras', label: 'En Vivo', Icon: Video },
  { to: '/devices/panels', label: 'Páneles', Icon: Radio },
  { to: '/devices/registro', label: 'Cámaras/NVR', Icon: Scan },
  { to: '/devices/inactivos', label: 'Bajas', Icon: PowerOff },
];

export function DispositivosLayout() {
  return (
    <div className="flex flex-col min-h-full">
      <div className="border-b border-border bg-background px-6 pt-4 shrink-0">
        <nav className="flex gap-1">
          {TABS.map(({ to, label, Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }: { isActive: boolean }) =>
                cn(
                  'flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors',
                  isActive
                    ? 'border-primary text-primary'
                    : 'border-transparent text-muted-foreground hover:text-foreground hover:border-muted-foreground/50'
                )
              }
            >
              <Icon className="w-4 h-4" />
              {label}
            </NavLink>
          ))}
        </nav>
      </div>
      <div className="flex-1">
        <Outlet />
      </div>
    </div>
  );
}
